import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    refresh();
  }, [refresh]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const isStaff = (u) => u && !["customer", "driver"].includes(u.role);
export const can = (u, p) => !!u?.permissions?.includes(p);

export function homeFor(u) {
  if (!u) return "/login";
  if (u.role === "driver") return "/driver";
  if (isStaff(u)) return "/admin";
  return "/account";
}

export function Protected({ children, roles, staff }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="p-16 text-slate-500" data-testid="auth-loading">Checking your session…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (staff && !isStaff(user)) return <Navigate to={homeFor(user)} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user)} replace />;
  return children;
}
